import "core-js/modules/es6.array.find-index";
var langCodeByNavigatorLang = {
  'ru': 'ru-ru',
  'en': 'en-us'
};
var langList = [{
  'label': 'English',
  'value': 'en-us'
}, {
  'label': 'Русский',
  'value': 'ru-ru'
}];
var navLang = window.navigator.language.substr(0, 2).toLowerCase();
var userFirstLang = langCodeByNavigatorLang[navLang] || 'en-us';
var index = langList.findIndex(function (item) {
  return item.value === userFirstLang;
});
langList.unshift(langList.splice(index, 1)[0]);
export var preparedLocales = langList;
export var locale = userFirstLang;